import React from 'react';
import { SocialFollow } from '../components';
import './pages.css';

const ContactPage = () => {
  return (
    <div className="page page--contact">
      <section className="page__hero page__hero--contact page__hero--compact page__hero--contact-compact">
        <div className="page__hero-content">
          <h1 className="gradient__text page__hero-title">Contact Us</h1>
        </div>
      </section>

      <div className="section__padding contact__section">
        <div className="contact__intro">
          <h2>Let's Connect</h2>
          <p>
            Reach out for event collaborations, artist opportunities, sponsorships, and community partnerships.
          </p>
        </div>

        <div className="contact__cards">
          <article className="contact__card">
            <h3>Email Us</h3>
            <p>We typically respond within 1-2 business days.</p>
            <a href="mailto:bollywoodkidhuncanada@gmail.com" className="contact__link">bollywoodkidhuncanada@gmail.com</a>
          </article>

         
        </div>

        <div className="contact__social">
          <SocialFollow />
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
